module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-ramen@2x-322a66324b277eab38ce5d9745a21392.png";